/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_Risk_LevelInputs */

const cs_investor_risk_level = /** @type {(inputs: Investor_Risk_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riziko`)
};

const en_investor_risk_level = /** @type {(inputs: Investor_Risk_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risk level`)
};

/**
* | output |
* | --- |
* | "Risk level" |
*
* @param {Investor_Risk_LevelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_risk_level = /** @type {((inputs?: Investor_Risk_LevelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_Risk_LevelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_risk_level(inputs)
	return cs_investor_risk_level(inputs)
});